import { render, staticRenderFns } from "./FeedReaction.vue?vue&type=template&id=9483a2d4&"
import script from "./FeedReaction.vue?vue&type=script&lang=ts&"
export * from "./FeedReaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports